import "../components/plasmic/redesigned_credit_storm_landing_app_credit_storm_2/plasmic.css"; // plasmic-import: wboCjrKjkicgLwUG7d8r4V/projectcss
import "@/styles/globals.css";
import "survey-core/survey-core.min.css";
import {LGRuntimeProvider, useRuntimeConfig} from "@lg-plus/landing-components";
import {GoogleTag} from "@lg-plus/landing-components/GoogleTag";
import {MetaPixel} from "@lg-plus/landing-components/MetaPixel";
import {PlasmicRootProvider} from "@plasmicapp/react-web";
import type {AppProps} from "next/app";
import Head from "next/head";
import Link from "next/link";

export default function MyApp({Component, pageProps}: AppProps) {
    const config = useRuntimeConfig(pageProps);

    return (
        <PlasmicRootProvider Head={Head} Link={Link}>
            <Head>
                <meta name="format-detection" content="telephone=no" />
                <link rel="icon" type="image/svg+xml" href="/favicon.svg" />
            </Head>
            <GoogleTag gtmId={config.gtmId} gtmCustomParams={config.gtmCustomParams} />
            <MetaPixel pixelId={config.metaPixelId} />
            <LGRuntimeProvider
                config={config}
                initialCommand={pageProps.initialCommand}
                initialFormData={pageProps.initialFormData}
                flashMessage={pageProps.flashMessage}
            >
                <Component {...pageProps} />
            </LGRuntimeProvider>
        </PlasmicRootProvider>
    );
}
